export default __webpack_public_path__ + "static/media/ajumoke.44602b81.png";